import BaseFilter from "./BaseFilter";
import gsap from "gsap";

export default class Filter extends BaseFilter {
    constructor() {
        super();
    }

    initPagination(el) {
        this.paginationItems = document.querySelectorAll(".js-pagination-item");
        if(el){
            this.paginationItems = el.querySelectorAll(".js-pagination-item");
        }
        if (this.paginationItems !== null) {
            this.paginationItems.forEach((item) => {
                item.addEventListener("click", (event) => {
                    event.preventDefault();

                    if (this.isFilterInProgress()) {
                        return;
                    }
                    this.disableFilter();
                    this.handlePaginationItem(event);
                });
            });
        }
    }

    handlePaginationItem(event) {
        this.page = event.target.getAttribute("data-val");

        if (!event.target.hasAttribute("data-val")) {
            this.page = event.target.closest(".js-pagination-item").getAttribute("data-val");
        }

        if (this.archiveResourcesMainWrapper) {
            this.smoothScrollToTop();
        }
        this.ajaxFilter(this.page);
    }

    smoothScrollToTop() {
        const list = document.querySelector(".js-resources-archive-main-wrapper");
        const doc = document.documentElement || document.body;

        let position = 0;

        if (list) {
            const listPosTop = list.getBoundingClientRect().top;
            const scrollPos = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            position = scrollPos + listPosTop - 200;
        }

        gsap.to(doc, {
            duration: 0.6,
            scrollTop: position,
            ease: "power3.out",
        });
    }
}
